import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import type { QualityMetrics, StudioGuideItem } from "@/lib/types"
import { MapPreview } from "./MapPreview"
import { PhonePreview } from "./PhonePreview"
import { QualityPanel } from "./QualityPanel"

interface PreviewPanelProps {
  items: StudioGuideItem[]
  quality: QualityMetrics
  selectedItemId: number | null
  onSelectItem: (id: number) => void
  regionCenter: [number, number] | null  // [lng, lat] from region.boundary_center
}

export function PreviewPanel({
  items,
  quality,
  selectedItemId,
  onSelectItem,
  regionCenter,
}: PreviewPanelProps) {
  return (
    <div className="sticky top-6">
      <Tabs defaultValue="phone">
        <TabsList className="h-7 gap-0.5 px-1">
          <TabsTrigger value="phone" className="h-5 px-2.5 text-xs">
            Phone
          </TabsTrigger>
          <TabsTrigger value="map" className="h-5 px-2.5 text-xs">
            Map
          </TabsTrigger>
          <TabsTrigger value="quality" className="h-5 px-2.5 text-xs">
            Quality
          </TabsTrigger>
        </TabsList>

        <div className="mt-3">
          <TabsContent value="phone" className="mt-0 flex justify-center">
            <PhonePreview
              items={items}
              selectedItemId={selectedItemId}
              onSelectItem={onSelectItem}
            />
          </TabsContent>

          <TabsContent value="map" className="mt-0">
            <MapPreview
              items={items}
              selectedItemId={selectedItemId}
              onSelectItem={onSelectItem}
              center={regionCenter}
            />
          </TabsContent>

          <TabsContent value="quality" className="mt-0">
            <QualityPanel quality={quality} />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  )
}
